import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LicenseContext = createContext(null);

// Se REACT_APP_LICENSE_MODE=local o sistema exige licença offline (build local/Docker).
// Padrão 'off' — nem bloqueia nem exibe banner. Útil para o modo SaaS/cloud atual.
const LICENSE_MODE = process.env.REACT_APP_LICENSE_MODE || 'off';

export const LicenseProvider = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/license/status`, { withCredentials: true });
      setStatus(data);
    } catch (e) {
      setStatus(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 5 * 60 * 1000);
    return () => clearInterval(id);
  }, [refresh]);

  useEffect(() => {
    if (user) refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const isLocalMode = LICENSE_MODE === 'local';
  const isBlocked = isLocalMode && !!status && status.active === false;
  const daysRemaining = status?.days_remaining;
  const showBanner = isLocalMode && !!status && status.active && (daysRemaining != null && daysRemaining <= 7);

  return (
    <LicenseContext.Provider value={{ status, loading, refresh, isBlocked, isLocalMode, daysRemaining, showBanner }}>
      {children}
    </LicenseContext.Provider>
  );
};

export const useLicense = () => {
  const ctx = useContext(LicenseContext);
  if (!ctx) throw new Error('useLicense deve estar dentro de LicenseProvider');
  return ctx;
};
